type DateValue = string | number | Date | null | undefined;

/** Returns a date in one language, or null when the value is empty or not a date. */
export function formatDate(
  value: DateValue,
  language: string,
  options?: Intl.DateTimeFormatOptions,
): string | null {
  if (value === null || value === undefined || value === '') return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toLocaleDateString(language, options);
}

/** Returns a date and time in one language, or null when the value is empty or not a date. */
export function formatDateTime(
  value: DateValue,
  language: string,
  options?: Intl.DateTimeFormatOptions,
): string | null {
  if (value === null || value === undefined || value === '') return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toLocaleString(language, options);
}

/** Returns a number in one language. */
export function formatNumber(value: number, language: string, options?: Intl.NumberFormatOptions): string {
  return value.toLocaleString(language, options);
}

/** Returns the capital first letters of the first two words of a name. */
export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? '')
    .join('');
}
